// ─── Hardcoded defaults (matches confirmed product-owner values) ──────────────
// DEFAULT_OU_ENABLED starts empty — hydrated from real OUs via useOUs() in RulesTab
export const DEFAULT_OU_ENABLED: Record<string, boolean> = {};

export const DEFAULT_CONFIG = {
  rn001Enabled: true,
  rn001: { minDur: 15, maxDur: 120, minPax: 2, maxPax: 50 },
  rn002Enabled: true,
  rn002: { exclRecur: true, exclWork: true, keywords: [] as string[] },
  rn003Enabled: true,
  rn003: { from: '08:00', to: '17:00' },
  rn004Enabled: true,
  rn004: { maxWeek: 10, maxPer: 5, interval: 2 },
  rn005Enabled: true,
  rn005: { maxDay: 2 },
};

// OUS removed — components now receive ous as prop from useOUs() in RulesTab
